import { FootchinkoItem } from "./FootchinkoItem";
import { GameConstants } from "../../GameConstants";
import { PegsContainer } from "../PegsContainer";
import { FootballFieldState } from "../../scenes/match-scene/FootballFieldState";

    export class ExtraBall extends FootchinkoItem {

        constructor(game: Phaser.Game, x: number, y: number) {

            super(game, x, y, "texture_atlas_1");

            this.canBeHit = true;
        }

        public setBody(): void {
            
            this.body.setCircle(28);
            this.body.static = true;
        }

        public setView(): void {

            super.setView();

            this.name = GameConstants.EXTRA_BALL;
            this.anchor.set(.5);

            // parte gráfica
            this.animations.add("spin", Phaser.Animation.generateFrameNames("balon_extra", 1, 7, "", 4), 16, true);
            this.animations.play("spin");
        }

        public hit(): void {

            this.canBeHit = false;

            // ponerlo en la z mas baja del pegscontainer
            var pegsContainer: PegsContainer = FootballFieldState.currentInstance.pegsContainer;
            pegsContainer.swap(pegsContainer.getBottom(), this);

            this.body.destroy();
            this.body = null;

            this.animations.stop("spin");

            this.frameName = "balon_extra0008";

            // tween en alpha y se auto destruye
            this.game.add.tween(this)
                .to({alpha: 0}, 500, Phaser.Easing.Quadratic.Out, true, 400)
                .onComplete.add(this.kill, this);
        }
    }
